// Student achievements in CRM (StudentDetail → "Yutuqlar") — GAMIFICATION_SPEC §6.
const achievements = {
  en: {
    title: 'Achievements',
    collected: '{unlocked} of {total} collected',
    combo: 'Best streak of correct answers: {best}',
    risk: 'Engagement risk',
    riskLOW: 'Low',
    riskMEDIUM: 'Medium',
    riskHIGH: 'High',
    inactiveDays: 'Inactive for {days} days',
    activeToday: 'Active today',
    neverActive: 'Not started yet',
    activeDays: '{days} active days in the last 4 weeks',
    suggestion: 'Suggested action',
    nextUp: 'Closest achievements',
    unlocked: 'Unlocked',
    none: 'No achievements yet.',
    give: 'Give praise',
    given: 'Praise given',
    notePlaceholder: 'What are you praising the student for? They will see this note.',
    send: 'Praise',
    sending: 'Sending…',
    cancel: 'Cancel',
    sent: 'Praise sent — the student gets a notification.',
    alreadyGiven: 'This student has already been praised.',
    failed: 'Could not award the achievement.',
    loadError: 'Could not load achievements.',
    eta: '~{days} d',
  },
  ru: {
    title: 'Достижения',
    collected: 'Собрано {unlocked} из {total}',
    combo: 'Лучшая серия верных ответов: {best}',
    risk: 'Риск ухода',
    riskLOW: 'Низкий',
    riskMEDIUM: 'Средний',
    riskHIGH: 'Высокий',
    inactiveDays: 'Не активен {days} дн.',
    activeToday: 'Активен сегодня',
    neverActive: 'Ещё не начал',
    activeDays: '{days} активных дней за 4 недели',
    suggestion: 'Рекомендация',
    nextUp: 'Ближайшие достижения',
    unlocked: 'Открытые',
    none: 'Пока нет достижений.',
    give: 'Похвалить',
    given: 'Похвала отправлена',
    notePlaceholder: 'За что вы хвалите ученика? Он увидит эту заметку.',
    send: 'Похвалить',
    sending: 'Отправляем…',
    cancel: 'Отмена',
    sent: 'Похвала отправлена — ученик получит уведомление.',
    alreadyGiven: 'Этого ученика уже похвалили.',
    failed: 'Не удалось выдать достижение.',
    loadError: 'Не удалось загрузить достижения.',
    eta: '~{days} дн.',
  },
  uz: {
    title: 'Yutuqlar',
    collected: "{total} tadan {unlocked} tasi yig'ilgan",
    combo: "Ketma-ket to'g'ri javoblar rekordi: {best}",
    risk: 'Faollik xavfi',
    riskLOW: 'Past',
    riskMEDIUM: "O'rta",
    riskHIGH: 'Yuqori',
    inactiveDays: '{days} kundan beri faol emas',
    activeToday: 'Bugun faol',
    neverActive: 'Hali boshlamagan',
    activeDays: 'Oxirgi 4 haftada {days} kun faol',
    suggestion: 'Tavsiya',
    nextUp: 'Eng yaqin yutuqlar',
    unlocked: 'Ochilgan yutuqlar',
    none: "Hali yutuqlar yo'q.",
    give: 'Maqtov berish',
    given: 'Maqtov berilgan',
    notePlaceholder: "O'quvchini nima uchun maqtayapsiz? U bu izohni ko'radi.",
    send: 'Maqtash',
    sending: 'Yuborilmoqda…',
    cancel: 'Bekor qilish',
    sent: "Maqtov yuborildi — o'quvchiga bildirishnoma boradi.",
    alreadyGiven: "Bu o'quvchi allaqachon maqtov olgan.",
    failed: "Yutuqni berib bo'lmadi.",
    loadError: "Yutuqlarni yuklab bo'lmadi.",
    eta: '~{days} kun',
  },
};

export default achievements;
